import { ValidateNested, IsString, IsNotEmpty } from 'class-validator';
import { Type } from 'class-transformer';
import get from 'lodash/get';

import DataDipNode from './Nodes/DataDipNodeDef';
import ExitNode from './Nodes/ExitNodeDef';
import ForwardNode from './Nodes/ForwardNodeDef';
import Http2Node from './Nodes/Http2NodeDef';
import InputNode from './Nodes/InputNodeDef';
import MenuNode from './Nodes/MenuNodeDef';
import MessageNode from './Nodes/MessageNodeDef';
import NODE_TYPES from './NodeTypes';
import NumberMatchNode from './Nodes/NumberMatchNodeDef';
import ScheduleNode from './Nodes/ScheduleNodeDef';
import SmsNode from './Nodes/SmsNodeDef';
import VariableMatchNode from './Nodes/VariableMatchNodeDef';
import VariableNode from './Nodes/VariableNodeDef';
import VoicemailNode from './Nodes/VoicemailNodeDef';
import VoiceAutomationNode from './Nodes/VoiceAutomationNodeDef';
import AutomationHandoffNode from './Nodes/AutomationHandoffNodeDef';

const nodeTypeClassMap = {
  IVR_NODE_DIAL: ExitNode,
  IVR_NODE_FORWARD: ForwardNode,
  IVR_NODE_HTTP: DataDipNode,
  IVR_NODE_INPUT: InputNode,
  IVR_NODE_MENU: MenuNode,
  IVR_NODE_MESSAGE: MessageNode,
  IVR_NODE_NUMBER_MATCH: NumberMatchNode,
  IVR_NODE_SCHEDULE: ScheduleNode,
  IVR_NODE_SMS: SmsNode,
  IVR_NODE_VARIABLE: VariableNode,
  IVR_NODE_VARIABLE_MATCH: VariableMatchNode,
  IVR_NODE_VOICEMAIL: VoicemailNode,
  IVR_NODE_HTTP2: Http2Node,
  IVR_NODE_VOICE_AUTOMATION: VoiceAutomationNode,
  IVR_NODE_HANDOFF: AutomationHandoffNode,
};

export default class IvrNode {
  @ValidateNested()
  @Type((typeHelper: any) => nodeTypeClassMap[get(typeHelper, 'object.type')])
  ivrNode:
    | DataDipNode
    | ExitNode
    | ForwardNode
    | Http2Node
    | InputNode
    | MenuNode
    | MessageNode
    | NumberMatchNode
    | ScheduleNode
    | SmsNode
    | VariableMatchNode
    | VariableNode
    | VoicemailNode
    | VoiceAutomationNode
    | AutomationHandoffNode;

  @IsString()
  @IsNotEmpty()
  type: NODE_TYPES;
}
